if buttons
    .appcues-social-buttons
        for button in buttons
            a.appcues-social-button(class=button.className, href=button.link, target='_blank')= button.text
